import type { FC } from 'react';

import Icon from 'app/components/Icon';
import logoIcon from 'app/icons/logo.svg';
import logoDevIcon from 'app/icons/logo-doc.svg';
import logoMinIcon from 'app/icons/logo-min.svg';

import style from './style.scss';

interface Props {
  collapsed: boolean;
}

const isDevEnv = process.env.ENVIRONMENT === 'development';

const AppLogo: FC<Props> = ({ collapsed }) => {
  if (isDevEnv) {
    if (collapsed) {
      return <div className={style.devIndicator}>Dev</div>;
    }

    return (
      <>
        <Icon href={logoDevIcon} className={style.devLogo} />
        <div className={style.devIndicator}>Dev</div>
      </>
    );
  }

  // if is production evironment
  if (collapsed) {
    return <Icon href={logoMinIcon} className={style.logoMin} />;
  }

  return <Icon href={logoIcon} className={style.logo} />;
};

AppLogo.displayName = 'AppLogo';

export default AppLogo;
